import React, { Component } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import queueRemote from '../../../api/queueRemote';

import { receiveError } from '../../../store/actions/notificationAction';
import { entryAddClearData, entryEditClearData } from '../../../store/actions/manualEntryEditAction';

import POSearchFilters from '../../common/POSearchFilters';
import PoAwbListContainer from './pickupOrderAwbsList/PoAwbListContainer';
import DriverQueueListModal from '../../driverQueue/ghaPage/DriverQueueListModal';
import GhaOrdersListContainer from './ghaOrdersList/GhaOrdersListContainer';
import ManualEntryModalContainer from './manualEntry/ManualEntryModalContainer';
import ManagedExportRightSideContainer from './export/ManagedExportRightSideContainer';
import ManageUnrecognizedDocContainer from '../../common/unrecognizedDocuments/ManageUnrecognizedDocContainer';

import User, { UserRoleType } from '../../../models/User';
import DriverData from '../../../models/DriverData';
import ApiResponse from '../../../models/ApiResponse';
import DriverQueue, { DriverQueueState, ResultDriverQueue } from '../../../models/DriverQueue';
import ResponseError from '../../../models/ResponseError';
import OrderSearchOptions from '../../../models/OrderSearchOptions';
import UnrecognizedDocs from "../../../models/AutoDocRecognitionResponse";

import { Moment } from 'moment';

import ghaManageOrdersWrapperStyles from './ghaManageOrdersWrapper.module.css';
import { SEARCH_OPTIONS_SCHEMA } from '../../../utils/searchOptions';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import Grid from '@material-ui/core/Grid';
import { Close } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";

import attachmentsRequestHandler from '../../../api/attachmentsRemote';
import { setWaitListId } from '../../../store/actions/waitListAction';
import EditAirwaybills from './EditAirwaybills';

const DRIVER_DATA_INITIALS: DriverData = {
  name: '',
  company: '',
  check_in: null
};

interface GhaManageOrdersWrapperProps {
  receiveError: Function;
  type: string;
  location: any;
  history: History;
  manualEntryEditClearData: () => void;
  manualEntryAddClearData: () => void;
  user: User;
  driverQueueState: DriverQueueState;
  counterId: number;
  setWaitListId: (driverId: number) => void;
  airlineCounters: Array<string>;
};

interface GhaManageOrdersWrapperState {
  orderType: string;
  selectedOrderNumber: string;
  selectedAwb: string;
  tempSearchOptions: OrderSearchOptions;
  searchOptions: OrderSearchOptions;
  openModalManualEntry: boolean;
  countWaitingList: number;
  queue: Array<DriverQueue>;
  isOpenWaitingList: boolean;
  idDriverQueueItem: number;
  openConfirmationDialog: boolean;
  driverData: DriverData;
  displayUnrecognizedDocs: boolean;
  countUnrecognizedDocs: number;
  counterSelectModal: boolean;
  waitingListId: number;
  appoints: number;
  walkIns: number;
  editAwbsModal: boolean;
  queueAirlines: string[];
};

class GhaManageOrdersWrapperContainer extends Component<GhaManageOrdersWrapperProps, GhaManageOrdersWrapperState> {

  intervalID: number | undefined;

  state: GhaManageOrdersWrapperState = {
    orderType: '',
    selectedOrderNumber: '',
    selectedAwb: '',
    tempSearchOptions: SEARCH_OPTIONS_SCHEMA,
    searchOptions: SEARCH_OPTIONS_SCHEMA,
    openModalManualEntry: false,
    countWaitingList: 0,
    queue: [],
    isOpenWaitingList: false,
    idDriverQueueItem: 0,
    openConfirmationDialog: false,
    driverData: DRIVER_DATA_INITIALS,
    displayUnrecognizedDocs: false,
    countUnrecognizedDocs: 0,
    counterSelectModal: false,
    waitingListId: -1,
    appoints: 0,
    walkIns: 0,
    editAwbsModal: false,
    queueAirlines: []
  }

  componentDidMount() {

    let selectedOrderNumber: string = '';
    let orderType: string = this.props.type;
    if (this.props.location.state) {
      selectedOrderNumber = this.props.location.state.orderNumber;
      orderType = this.props.location.state.orderType;
    }

    this.setState({ orderType: orderType, selectedOrderNumber });
    this.loadUnrecognizedDocs();
    this.filterQueue(this.props.driverQueueState.queue);
  }

  componentDidUpdate(prevProps: GhaManageOrdersWrapperProps) {

    if (prevProps.type !== this.props.type) {
      this.setState({
        orderType: this.props.type,
        selectedOrderNumber: '-1',
        selectedAwb: '',
        tempSearchOptions: SEARCH_OPTIONS_SCHEMA,
        searchOptions: SEARCH_OPTIONS_SCHEMA,
        driverData: DRIVER_DATA_INITIALS
      });
    }
    if(prevProps.airlineCounters !== this.props.airlineCounters) {
      this.filterQueue(this.props.driverQueueState.queue);
    }
    if(prevProps.driverQueueState.queue.length !== this.props.driverQueueState.queue.length || prevProps.type !== this.props.type) {
      this.filterQueue(this.props.driverQueueState.queue);
    }
  }

  handlePoNumberChange = (number: string): void => {

    const selectedOrderNumber: string = number;
    this.setState({ selectedOrderNumber });
  }


  selectFirstPickupOrder = (selectedOrderNumber: string): void => {
    this.setState({ selectedOrderNumber });
  }

  handleChangeDate = (type: string, date: Moment): void => {

    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };
    const days = searchOptions.endDate.diff(date, 'days');
    const date1 = date.clone();
    if(type === 'startDate' && days >= 30) {
      searchOptions.endDate = date.add('days', 30);
    }
    switch (type) {
      case 'startDate':
        searchOptions.startDate = date1;
        break;
      case 'endDate': searchOptions.endDate = date; break;
      default: break;
    }

    this.setState({ tempSearchOptions: searchOptions });
  }

  handleChangeKeyword = (event: any): void => {

    const value: string = event.target.value;
    const keyword: string = value.toUpperCase();
    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };

    searchOptions.keyword = keyword;
    this.setState({ tempSearchOptions: searchOptions });
  }

  handleChangeTime = (type: string, event: any): void => {

    const time: string = event.target.value;
    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };

    switch (type) {
      case 'startTime': searchOptions.startTime = time; break;
      case 'endTime': searchOptions.endTime = time; break;
      default: break;
    }

    this.setState({ tempSearchOptions: searchOptions });
  }

  handleClick = (): void => {

    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };
    searchOptions.keyword = '';
    searchOptions.currDate = false;

    this.setState({ tempSearchOptions: searchOptions });
  }

  search = (): void => {
    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };

    if (searchOptions.keyword && searchOptions.keyword !== '' && searchOptions.keyword.length >= 3 ) {
      searchOptions.ignoreDateAndTime = true;
    };
 

    if (searchOptions.keyword && searchOptions.keyword !== '' && searchOptions.keyword.length < 3 ) {

      searchOptions.errorKeyword = true;
    }

    this.setState({ searchOptions });
  }

  disabledDate = (): void => {

    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };
    searchOptions.currDate = true;

    this.setState({ tempSearchOptions: searchOptions });
  };

  changeFocuses = (): void => {

    const searchOptions: OrderSearchOptions = { ...this.state.tempSearchOptions };

    searchOptions.errorKeyword = false;

    if (searchOptions.keyword === '') {
      searchOptions.currDate = false;
    }

    this.setState({ tempSearchOptions: searchOptions });
  }

  setSelectedAwb = (awbNumber: string):void => {
    this.setState({ selectedAwb: awbNumber });
  }

  handleCloseManualEntry = (isUpdated?: boolean, edit?: boolean, cancel?: boolean): void => {
    if(cancel && this.state.waitingListId !== -1) {
      this.setCounter(this.state.waitingListId, 'check_in');
    }
    const driverData: DriverData = DRIVER_DATA_INITIALS;
    this.props.manualEntryEditClearData();
    this.setState({ openModalManualEntry: false, driverData, waitingListId: -1 });
  }

  openCloseEditAwbs = (type: string): void => {
    if(type === 'open') {
      this.setState({ editAwbsModal: true });
    } else {
      this.setState({ editAwbsModal: false });
    }
  }

  handleOpenModalManualEntry = (): void => {
    this.props.manualEntryEditClearData();
    this.props.manualEntryAddClearData();
    this.setState({ openModalManualEntry: true });
  }

  filterQueue = (listQueue: Array<DriverQueue>): void => {
    const filterType: string = this.props.type === 'po' ? 'import' : 'export';
    let appoints = 0, walkIns = 0;
    const airlines: Set<string> = new Set(); 
    const queue: Array<DriverQueue> = listQueue.filter(item => item.info.type === filterType);
  
    let filteredQueue = [...queue]; // By default, set filteredQueue to the entire queue
  
    if (this.props.airlineCounters.length > 0) {
      const airlineCountersSet = new Set(this.props.airlineCounters); // Convert airlineCounters to a Set for efficient lookup
  
      filteredQueue = queue.filter(driver => {
        const driverAirlines = driver.info.airlines || [];
        return driverAirlines.some(airline => airlineCountersSet.has(airline));
      });
    }
  
    for (let index = 0; index < filteredQueue.length; index++) {
      const element = filteredQueue[index];
      if (element.info.appointment) {
        appoints++;
      } else {
        walkIns++;
      }
      if (element.info.airlines) {
        element.info.airlines.forEach(airline => {
          airlines.add(airline);
        });
      } 
    }
  
    const queueAirlines: Array<string> = Array.from(airlines);
    this.setState({
      queue: filteredQueue,
      appoints,
      walkIns,
      countWaitingList: filteredQueue.length,
      queueAirlines
    });
  }

  handleOpenWaitingList = (): void  => {
    this.setState({ isOpenWaitingList: true });
  }

  handleCloseWaitingList = (): void => {
    this.setState({ isOpenWaitingList: false });
  }

  controlCounter = (value: boolean) => {
    this.setState({ counterSelectModal: value });
  }

  deleteDriverInQueue = (id: number): void => {
    this.setState({ idDriverQueueItem: id, openConfirmationDialog: true });
  }

  deleteItemOfDriverInQueue = (): void => {
    queueRemote.deleteDriverOfQueue(this.state.idDriverQueueItem).then((resp: ApiResponse<Array<DriverQueue>>) => {

      const listQueue : Array<DriverQueue> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (listQueue) {
        this.filterQueue(listQueue);
        this.closeConfirmationDialog();
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  setCounter = (id: number, type: string): void => {
    if(id) {
      if(type === 'counter') {
        this.props.setWaitListId(id);
      } else {
        this.props.setWaitListId(0);
      }
      queueRemote.callDriver(id, type).then((res: ApiResponse<any>) => {
        const result: any | undefined = res.success;
        const error: ResponseError | undefined = res.error;
  
        if (result) {
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      });
    }
    
  }

  closeConfirmationDialog = (): void => {
    this.setState({ openConfirmationDialog: false, idDriverQueueItem: 0 });
  }

  createNewOrder = (data: DriverQueue): void => {
    if(this.props.counterId) {
      this.setState({ waitingListId: data.id }, () => {
        this.setCounter(data.id, 'counter');
        const driverData: DriverData = { ...this.state.driverData };
        driverData.name = data.info.first_name + ' ' + data.info.last_name;
        driverData.company = data.info.company;
        driverData.check_in = data.check_in;
        driverData.driverId = data.id;
        this.setState({ driverData, idDriverQueueItem: data.id, isOpenWaitingList: false });
        this.props.manualEntryEditClearData();
        this.setState({ openModalManualEntry: true });
      })
     
    } else {
      this.controlCounter(true);
    }
   
  }

  loadUnrecognizedDocs = (): void => {
    attachmentsRequestHandler.loadUnrecognizedAttachments().then((resp: ApiResponse<Array<UnrecognizedDocs>>) => {
      const result: Array<UnrecognizedDocs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ countUnrecognizedDocs: result.length });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleShowUnrecognizedDocs = (): void  => {
    this.setState({ displayUnrecognizedDocs: true });
  }

  handleHideUnrecognizedDocs = (): void => {
    this.setState({ displayUnrecognizedDocs: false, countUnrecognizedDocs: 0 });
    this.loadUnrecognizedDocs();
  }

  render() {

    return (
      <div>
        <div className={ this.state.displayUnrecognizedDocs ? ghaManageOrdersWrapperStyles.hide : ghaManageOrdersWrapperStyles.show } >
          <div className={ ghaManageOrdersWrapperStyles.searchFilters }>
            <POSearchFilters
              handleClick={ this.handleClick }
              changeFocuses={ this.changeFocuses }
              openModalManualEntry={ this.handleOpenModalManualEntry }
              userRole={ UserRoleType.GHA }
              countWaitingList={ this.state.countWaitingList }
              handleOpenWaitingList={ this.handleOpenWaitingList }
              countUnrecognizedDocs={ this.state.countUnrecognizedDocs }
              handleShowUnrecognizedDocs= { this.handleShowUnrecognizedDocs }
            />
          </div>
          <div className={ ghaManageOrdersWrapperStyles.mainWrapper }>
            <Grid container >
              <Grid item className={ ghaManageOrdersWrapperStyles.posWrapperContainer } >
                <div className={ ghaManageOrdersWrapperStyles.posWrapper }>
                  <GhaOrdersListContainer
                    history={ this.props.history }
                    type={ this.state.orderType }
                    startDate={ this.state.tempSearchOptions.startDate }
                    endDate={ this.state.tempSearchOptions.endDate }
                    startTime={ this.state.tempSearchOptions.startTime }
                    endTime={ this.state.tempSearchOptions.endTime }
                    handleChangeDate={ this.handleChangeDate }
                    handleChangeTime={ this.handleChangeTime }
                    search={ this.search }
                    handleChange={ this.handlePoNumberChange }
                    selectedPoNumber={ this.state.selectedOrderNumber }
                    selectFirstPickupOrder={ this.selectFirstPickupOrder }
                    searchOptions={ this.state.searchOptions }
                    errorKeyword={ this.state.tempSearchOptions.errorKeyword }
                    keyword={ this.state.tempSearchOptions.keyword }
                    handleChangeKeyword={ this.handleChangeKeyword }
                    handleClick={ this.handleClick }
                    disabledDate={ this.disabledDate }
                    currDate={ this.state.tempSearchOptions.currDate }
                    changeFocuses={ this.changeFocuses }
                  />

                  { this.state.isOpenWaitingList &&
                    <DriverQueueListModal
                      queue={ this.state.queue }
                      deleteDriverInQueue={ this.deleteDriverInQueue }
                      createNewOrder={ this.createNewOrder }
                      isOpenWaitingList={ this.state.isOpenWaitingList }
                      handleCloseWaitingList={ this.handleCloseWaitingList }
                      type={ this.state.orderType }
                      counterSelectModal={ this.state.counterSelectModal }
                      closeDialog={ this.controlCounter }
                      appoints={ this.state.appoints }
                      walkIns={ this.state.walkIns }
                      airlines={ this.state.queueAirlines }
                    />
                  }

                  { this.state.openModalManualEntry &&
                    <ManualEntryModalContainer
                      type={ this.state.orderType }
                      history={ this.props.history }
                      modalOpen={ this.state.openModalManualEntry }
                      handleCloseModal={ this.handleCloseManualEntry }
                      driverData={ this.state.driverData }
                    />
                  }

                  { this.state.editAwbsModal &&
                    <EditAirwaybills
                      type={ this.state.orderType }
                      handleCloseModal={ this.openCloseEditAwbs }
                      selectedOrderNumber={ this.state.selectedOrderNumber }
                      modalOpen={this.state.editAwbsModal}
                    />
                  }

                  { this.state.openConfirmationDialog &&
                    <ConfirmationDialog
                      open={ this.state.openConfirmationDialog }
                      close={ this.closeConfirmationDialog }
                      title='Delete Confirmation'
                      text='This item will be permanently removed. To confirm deletion click on the “Delete” button.'
                      textConfirm='delete'
                      confirm={ this.deleteItemOfDriverInQueue }
                      showCloseIcon={ true }
                    />
                  }
                </div>
              </Grid>
              <Grid item className={ ghaManageOrdersWrapperStyles.awbsWrapperContainer } >
                <div className={ ghaManageOrdersWrapperStyles.awbsWrapper }>
                  { this.state.orderType === 'po' &&
                    <PoAwbListContainer
                      selectedPoNumber={ this.state.selectedOrderNumber }
                      selectedAwb={ this.state.selectedAwb }
                      setSelectedAwb={ this.setSelectedAwb }
                      history={ this.props.history }
                      openCloseEditAwbs={this.openCloseEditAwbs}
                    />
                  }
                  { this.state.orderType === 'do' && 
                  <ManagedExportRightSideContainer 
                    selectedDooNumber={ this.state.selectedOrderNumber }
                    openModalManualEntry={ this.handleOpenModalManualEntry }
                    history={ this.props.history }
                    openCloseEditAwbs={ this.openCloseEditAwbs }
                  /> 
                  }
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
       { this.state.displayUnrecognizedDocs && <div className={ !this.state.displayUnrecognizedDocs ? ghaManageOrdersWrapperStyles.hide : ghaManageOrdersWrapperStyles.show } >
          <div className={ ghaManageOrdersWrapperStyles.unrecognizedDocModal }>
            <IconButton aria-label="Close" className={ ghaManageOrdersWrapperStyles.unrecognizedDocBtn } onClick={ this.handleHideUnrecognizedDocs }>
              <Close color="primary" />
            </IconButton>
            <ManageUnrecognizedDocContainer
              displayUnrecognizedDocs={ this.state.displayUnrecognizedDocs }
            />
          </div>
        </div> }
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    driverQueueState: state.driverQueue,
    counterId: state.userCounter,
    airlineCounters: state.counterAirlines
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    manualEntryEditClearData: () => dispatch(entryEditClearData()),
    manualEntryAddClearData: () => dispatch(entryAddClearData()),
    setWaitListId: (driverId: number) => dispatch(setWaitListId(driverId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GhaManageOrdersWrapperContainer);
